import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

import ClerkBackground from "./assets/ClerkDashboardBackground.jpg";
import SubPracBackground from "./assets/SubPracDashboardBackground.jpg";

export const background = css`
  height: 100vh;
  background-color: ${colors.background};
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: ${dimensions.desktopMax}) {
    background-position: 15% center;
  }
`;

export const clerkBackground = css`
  background-image: url("${ClerkBackground}");
`;

export const subPracBackground = css`
  background-image: url("${SubPracBackground}");
`;
